import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { login, logout, getInfo, getCurrentUser, phoneLogin, emailLogin, syncBbsSession } from '@/api/user'
import {
  getToken,
  setToken,
  removeToken,
  setUserName,
  getUserName,
  normalizeUserName,
  removeUserName
} from '@/utils/auth'
import storage from '@/utils/storage'
import router from '@/router'
import Custom from './modules/custom.js'
Vue.use(Vuex)
const store = new Vuex.Store({
  namespaced:true,
  modules: {
    custom: Custom
  },
  state: {
    /* User */
    token: getToken(),
    curUserName: getUserName(),
    numbUserName: null,
    // username: null,
    username: getUserName() || null,
    userEmail: null,
    name: null,
    userAvatar: null,
    roles: [],
    /* NavBar */
    isNavBarVisible: true,

    /* FooterBar */
    isFooterBarVisible: true,

    /* Aside */
    isAsideVisible: false,
    isAsideMobileExpanded: false,

    /* Sample data (commonly used) */
    clients: []
  },
  mutations: {
    /* A fit-them-all commit */
    SET_USER_NAME (state, username) {
      const normalizedName = normalizeUserName(username)
      if (normalizedName) {
        state.username = normalizedName
        setUserName(normalizedName) // 存储到 Cookie (7天过期)
      } else {
        state.username = null
        removeUserName()
      }
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.numbUserName = name
    },
    basic (state, payload) {
      state[payload.key] = payload.value
    },
    updateUsername ({ commit }, username) {
      commit('SET_USERNAME', username)
    },
    /* User */
    // user (state, payload) {
    //   if (payload.name) {
    //     state.userName = payload.name
    //   }
    //   if (payload.email) {
    //     state.userEmail = payload.email
    //   }
    //   if (payload.avatar) {
    //     state.userAvatar = payload.avatar
    //   }
    // },

    /* Aside Mobile */
    asideMobileStateToggle (state, payload = null) {
      const htmlClassName = 'has-aside-mobile-expanded'

      let isShow

      if (payload !== null) {
        isShow = payload
      } else {
        isShow = !state.isAsideMobileExpanded
      }

      if (isShow) {
        document.documentElement.classList.add(htmlClassName)
      } else {
        document.documentElement.classList.remove(htmlClassName)
      }

      state.isAsideMobileExpanded = isShow
    },

    /* Full Page mode */
    fullPage (state, payload) {
      state.isNavBarVisible = !payload
      state.isAsideVisible = !payload
      state.isFooterBarVisible = !payload
    }
  },
  actions: {
    asideDesktopOnlyToggle (store, payload = null) {
      let method

      switch (payload) {
        case true:
          method = 'add'
          break
        case false:
          method = 'remove'
          break
        default:
          method = 'toggle'
      }
      document.documentElement.classList[method]('has-aside-desktop-only-visible')
    },
    toggleFullPage ({ commit }, payload) {
      commit('fullPage', payload)
      const aa = {
        '业务招待1': [
          {label: '1月', value: 23},
          {label: '2月', value: 23},
          {label: '3月', value: 23},
          {label: '4月', value: 23},
        ],
        '业务招待2': [
          {label: '1月', value: 23},
          {label: '2月', value: 23},
          {label: '3月', value: 23},
          {label: '4月', value: 23},
        ]
      }
      document.documentElement.classList[!payload ? 'add' : 'remove']('has-aside-left', 'has-navbar-fixed-top')
    },
    // user login
    login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(async response => {
          // 优先显示用户名(username)，其次昵称，最后登录账号(手机/邮箱)
          const user = (response && response.data && response.data.user) || {}
          let username = normalizeUserName(user.username)
            || normalizeUserName(user.nickname)
            || normalizeUserName(response.nickName)
            || normalizeUserName(userInfo.username)
            || ''
          const { token } = response
          commit('SET_TOKEN', token)
          commit('SET_USER_NAME', username)
          setToken(token)
          await syncBbsSession(token)
          setUserName(username)
          const attemptedURL = sessionStorage.getItem('attemptedURL')
          if (attemptedURL) {
            router.push(attemptedURL)
            sessionStorage.removeItem('attemptedURL')
          } else {
            // 如果没有尝试访问的URL，跳转到默认页面
            router.push('/')
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 手机验证码登录
    phoneLoginAction ({ commit }, phoneInfo) {
      return new Promise((resolve, reject) => {
        phoneLogin(phoneInfo).then(async response => {
          const user = (response && response.data && response.data.user) || {}
          let username = normalizeUserName(user.username)
            || normalizeUserName(user.nickname)
            || normalizeUserName(response.nickName)
            || normalizeUserName(phoneInfo.phone)
            || ''
          const { token } = response
          commit('SET_TOKEN', token)
          commit('SET_USER_NAME', username)
          setToken(token)
          await syncBbsSession(token)
          setUserName(username)
          const attemptedURL = sessionStorage.getItem('attemptedURL')
          if (attemptedURL) {
            router.push(attemptedURL)
            sessionStorage.removeItem('attemptedURL')
          } else {
            // 如果没有尝试访问的URL，跳转到默认页面
            router.push('/')
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 邮箱验证码登录
    emailLoginAction ({ commit }, emailInfo) {
      return new Promise((resolve, reject) => {
        emailLogin(emailInfo).then(async response => {
          const user = (response && response.data && response.data.user) || {}
          let username = normalizeUserName(user.username)
            || normalizeUserName(user.nickname)
            || normalizeUserName(response.nickName)
            || normalizeUserName(emailInfo.email)
            || normalizeUserName(emailInfo.account)
            || ''
          const { token } = response
          commit('SET_TOKEN', token)
          commit('SET_USER_NAME', username)
          setToken(token)
          await syncBbsSession(token)
          setUserName(username)
          const attemptedURL = sessionStorage.getItem('attemptedURL')
          if (attemptedURL) {
            router.push(attemptedURL)
            sessionStorage.removeItem('attemptedURL')
          } else {
            // 如果没有尝试访问的URL，跳转到默认页面
            router.push('/')
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // WeChat exchange returns the same main-site session contract as other logins.
    async wechatLoginAction ({ commit }, response) {
      const payload = response && response.data ? response.data : response
      const token = payload && payload.token
      if (!token) return Promise.reject(new Error('微信登录凭证为空'))
      const user = payload.user || {}
      const username = [
        user.username,
        user.nickname,
        user.nickName,
        payload.nickName,
        user.realName,
      ].map(normalizeUserName).find(Boolean) || ''
      commit('SET_TOKEN', token)
      commit('SET_USER_NAME', username)
      setToken(token)
      await syncBbsSession(token)
      setUserName(username)
      const attemptedURL = sessionStorage.getItem('attemptedURL')
      if (attemptedURL) { router.push(attemptedURL); sessionStorage.removeItem('attemptedURL') } else router.push('/')
      return Promise.resolve(response)
    },
    restoreUserName ({ commit, state, getters }) {
      if (!getters.getUserToken || state.username) return Promise.resolve(state.username)
      return getCurrentUser().then(response => {
        const user = response && response.data ? response.data : response
        const username = [
          user && user.username,
          user && user.nickname,
          user && user.nickName,
          user && user.realName
        ].map(normalizeUserName).find(Boolean) || ''
        commit('SET_USER_NAME', username)
        return username
      })
    },
    clearToken({ commit, dispatch }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USER_NAME', '')
        removeToken()
        removeUserName()
        storage.clear()
        console.log('clearToken success')
        resolve()
      })
    },
    resetToken ({ commit, dispatch }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USER_NAME', '')
        removeToken()
        removeUserName()
        storage.clear()
        console.log('resetToken success')
        const loginEvent = new CustomEvent('csCustomLoginEvent', {
          detail: {}, // 自定义事件的详细信息
          bubbles: true, // 事件是否冒泡
          cancelable: true // 事件是否可以被取消
        });
        document.dispatchEvent(loginEvent);
        resolve()
      })
    },
    // 退出系统
    async LogOut ({ dispatch }) {
      try {
        await logout()
      } finally {
        await dispatch('resetToken')
      }
    },
    // get user info
    getInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          if (!response || !response.data) {
            // commit('SET_TOKEN', '')
            removeToken()
            resolve()
          }

          // const { roles, name, avatar, introduction, permissions } = response.data

          // roles must be a non-empty array
          // if (!roles || roles.length <= 0) {
          //   // eslint-disable-next-line prefer-promise-reject-errors
          //   reject('getInfo: roles must be a non-null array!')
          // }
          // commit('SET_PERMISSIONS', permissions)
          // commit('SET_ROLES', roles)
          // console.log('set name 222222222', name)
          // commit('SET_NAME', name)
          // commit('SET_AVATAR', avatar)
          // commit('SET_INTRODUCTION', introduction)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetch ({ commit }, payload) {
      axios
        .get(`data-sources/${payload}.json`)
        .then((r) => {
          // if (r.data && r.data.data) {
          //   commit('basic', {
          //     key: payload,
          //     value: r.data.data
          //   })
          // }
        })
        .catch(error => {
          alert(error.message)
        })
    }
  },
  getters: {
    getUserToken(state) {
      if (!state.token) {
        state.token = getToken()
      }
      return state.token
    }
  }
})
export default store
export function useStore () {
  return store
}
